<fieldset class="border mt-2 mb-3 ps-2">
  <legend class="w-auto m-0 p-0">Referral {{ position + 1 }}</legend>
  <div class="pb-2 ps-1 form-inline">
    <label><strong>Documentation Date</strong></label>
    <div class="input-group referral-date ms-2">
      <input
        name="referralDate"
        type="date"
        class="form-control referral-date-input"
        autocomplete="off"
        autofocus
        placeholder="MM/DD/YYYY"
        [disabled]="disabled"
        [(ngModel)]="referralDate"
        (blur)="onReferralDateBlur()"
        />
      @if (referralDate && !disabled) {
        <button
          (click)="onDateClearClick()"
          class="btn clear-button"
          type="button">
          <span>×</span>
        </button>
      }
    </div>
    @if (!disabled) {
      <div class="actions ms-2">
        @if (position > 0) {
          <a
            href="#/remove"
            class="text-danger ms-1 text-small"
            (click)="onRemoveClick($event, verification)">
            Remove
          </a>
        }
      </div>
    }
  </div>
</fieldset>
